import api from './api';

const resource = 'Inventory/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const categories = async (query = '') => {
  return await api.get(resource + 'Categories' + query);
};

export const bulkUpdate = async (body) => {
  return await api.post(resource + 'BulkUpdate', body);
};

const inventoryApi = { list, categories, bulkUpdate };

export default inventoryApi;
